// The pluggable AI seam. Today there's one provider (Anthropic, called directly
// from the browser with the user's own key); a backend proxy or other vendors can
// implement the same interface later without touching the feature code.

export type FeedbackKind = "challenge" | "interview";

/** Everything an AI mentor needs to critique one answer. */
export interface FeedbackRequest {
  kind: FeedbackKind;
  /** Short title of the challenge / question. */
  title: string;
  /** The full task or question prompt the user was answering. */
  task: string;
  /** Optional framing: rolled game concept, or role · format. */
  context?: string;
  /** Rubric points a strong answer covers, if available. */
  idealPoints?: string[];
  /** The user's written answer. */
  response: string;
}

export interface AIConfig {
  apiKey: string;
  model: string;
}

export interface AIProvider {
  id: string;
  label: string;
  /** Single-shot critique. Returns Markdown for the app to render. */
  feedback: (req: FeedbackRequest, signal?: AbortSignal) => Promise<string>;
  /** Generic single-shot prompt — used by Triage for follow-ups & gap reports. */
  ask: (system: string | undefined, user: string, maxTokens?: number, signal?: AbortSignal) => Promise<string>;
  /** Cheap round-trip to verify the key/model work. */
  test: (signal?: AbortSignal) => Promise<void>;
}

/** Thrown for any provider call failure, with a user-readable message. */
export class AIError extends Error {}
